import {Directive, HostListener} from '@angular/core';

declare const $: any;

// Bootstrap's data-toggle="collapse" genuinely toggles: clicking the link for
// the already-open panel collapses it, leaving the dashboard shell's content
// column blank. These nav-rail links are meant to *select* a panel, not
// toggle it, so a click on the currently-active one should be a no-op.
// Matches every `.btn-user-profile[data-toggle="collapse"]` site-wide (the
// nav-rail's own link, not the mobile show/hide toggle), so this applies
// uniformly with no changes needed in each page's template.
@Directive({
    selector: '[data-toggle="collapse"].btn-user-profile'
})
export class KeepCollapseOpenDirective {

    @HostListener('click', ['$event'])
    onClick(event: MouseEvent): void {
        const target = (event.currentTarget as HTMLElement).getAttribute('data-target');
        if (target && $(target).hasClass('show')) {
            event.stopPropagation();
            event.preventDefault();
        }
    }
}
